import { BellRing, Mail, MessageCircle, MessageSquareText, MessagesSquare, Plug } from 'lucide-react';

/**
 * An icon for a channel id. Presentation only: a channel this map does not know
 * still works everywhere, and gets the generic plug.
 */
const ICONS: Record<string, typeof Plug> = {
  sms: MessageSquareText,
  email: Mail,
  whatsapp: MessageCircle,
  rcs: MessagesSquare,
  push: BellRing,
};

export function ChannelIcon({ channel, className = 'size-4' }: { channel: string; className?: string }) {
  const Icon = ICONS[channel] ?? Plug;
  return <Icon className={className} aria-hidden />;
}
